import { PropsWithChildren, ReactElement } from "react";
import { Provider } from "react-redux";
import AgentHubEventsProviderWrapper from "../../components/providers/AgentHubEventsProviderWrapper";
import HostContextProvider from "../../components/providers/HostContextProvider";
import AuthProvider from "../../components/providers/auth/AuthProvider";
import ThemeProviders from "../../components/providers/theme/ThemeProviders";
import { store } from "../../redux/store";
import ActivityInfoProvider from "./ActivityInfoContext.Provider";
import AgentStateProvider from "./AgentStateContext.Provider";
import AntDesignAppProvider from "./AntDesignAppProvider";
import NotificationProvider from "./NotificationContext.Provider";
import SettingsProvider from "./SettingsContext.Provider";
import TranslationOverrideProvider from "./TranslationOverrideContext.Provider";
import TranslationProvider from "./TranslationProvider";
import WebRtcSessionProviderWrapper from "./WebRtcSessionProviderWrapper";
import WorkItemInfoProvider from "./WorkItemInfoContext.Provider";

/**
 * Shared providers between the Main and CRM apps.
 */
export default function BaseProviders({ children }: PropsWithChildren): ReactElement {
  return (
    <Provider store={store}>
      <TranslationOverrideProvider>
        <TranslationProvider>
          <SettingsProvider>
            <ThemeProviders>
              <AntDesignAppProvider>
                <NotificationProvider>
                  <AuthProvider>
                    <AgentHubEventsProviderWrapper>
                      <HostContextProvider>
                        <AgentStateProvider>
                          <WorkItemInfoProvider>
                            <ActivityInfoProvider>
                              <WebRtcSessionProviderWrapper>
                                {children}
                              </WebRtcSessionProviderWrapper>
                            </ActivityInfoProvider>
                          </WorkItemInfoProvider>
                        </AgentStateProvider>
                      </HostContextProvider>
                    </AgentHubEventsProviderWrapper>
                  </AuthProvider>
                </NotificationProvider>
              </AntDesignAppProvider>
            </ThemeProviders>
          </SettingsProvider>
        </TranslationProvider>
      </TranslationOverrideProvider>
    </Provider>
  );
}
